import { render, staticRenderFns } from "./HistoricoProdutoDialog.vue?vue&type=template&id=03e7d75f&"
import script from "./HistoricoProdutoDialog.vue?vue&type=script&lang=js&"
export * from "./HistoricoProdutoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports